import { render, staticRenderFns } from "./PurchaseRequestCount.vue?vue&type=template&id=22b761c1&"
import script from "./PurchaseRequestCount.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequestCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports